import { Rescatable } from '../Rescatable';
import { ProductImage } from '../ProductImage';
import { Subcategory } from './Subcategory';
import { Brand } from './Brand';
import { FeaturesProduct } from './FeaturesProduct';
import { ProductDetails } from './ProductDetails';
import { LiquidationModel } from 'src/app/products/components/liquidation-section/components/liquidation-card/liquidation-card.model';

export class Product extends Rescatable {
  static _name = 'Product';
  static pathRequest = Rescatable.pathRequestStatic + 'productos';
  static pathRequestIndex = Rescatable.pathRequestStatic + 'productos';
  static pk: keyof Product = 'id_producto';

  // TODO: Deprecate once search/filters improve is ready

  public score: number;
  public normalizedScore: number;
  public appearedIteration: Array<string | number>;
  public searchMatches: Array<{
    words: Array<string>;
    key: string;
    value: string;
  }>;
  public clusteringCut?: boolean;

  // End Deprecate

  id_producto: number;
  codigo_principal?: string[] | null;
  imagenes?: ProductImage[];
  nombre: string;
  iva?: number;
  precioEspecial?: number;
  precioLista: number;
  precioEspecialAnterior: number;
  precioListaAnterior: number;
  precioEspecialCombo?: number;
  precioListaCombo?: number;
  id_marca: number;
  id_categoria: number | string;
  codigo?: string;
  destacado: number;
  id_subcategoria: number;
  sale?: boolean;
  coins: number;
  coins_sale: number;
  coins_forzada: number;
  precio_bruto: number;
  descuento_liquidacion: number;
  garantia?: string | number;
  vendible?: number;
  cantidad?: number;
  cantidad_id?: string;
  $subcategory?: Subcategory;
  $brand?: Brand;
  $features?: FeaturesProduct;
  $details?: ProductDetails;
  $liquidation?: LiquidationModel[];
  stock?: number;
  $quantity?: number;
  garantia_oficial?: number;
  cantidadCarrito?: Array<any>;
  $caracteristicas: { [x: string]: any };

  constructor(e: Product) {
    super(e);
  }
}
